// 公共方法规则：首字母大写

/**
 * @desc 日期时间格式化
 * @param {string} [type='']
 * @returns
 */
function FormatDateTime(dateTime = new Date(), type = '') {
  let oldDateTime = dateTime
  let newDateTime = ''

  let dividerDate = '-'
  let dividerTime = ':'

  let year = oldDateTime.getFullYear()
  let month = oldDateTime.getMonth() + 1
  let date = oldDateTime.getDate()
  let hours = oldDateTime.getHours()
  let minutes = oldDateTime.getMinutes()
  let seconds = oldDateTime.getSeconds()

  if (month >= 1 && month <= 9) month = '0' + month
  if (date >= 0 && date <= 9) date = '0' + date
  if (hours >= 0 && hours <= 9) hours = '0' + hours
  if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
  if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds

  switch (type) {
    case 'date':
      newDateTime = `${year}${dividerDate}${month}${dividerDate}${date}`
      break

    case 'fullTime':
      newDateTime = `${hours}${dividerTime}${minutes}${dividerTime}${seconds}`
      break

    case 'time':
      newDateTime = `${hours}${dividerTime}${minutes}`
      break

    case 'year-month':
      newDateTime = `${year}${dividerDate}${month}`
      break

    case 'dateTime':
      newDateTime = `${year}${dividerDate}${month}${dividerDate}${date} ${hours}${dividerTime}${minutes}`
      break

    default:
      newDateTime = `${year}${dividerDate}${month}${dividerDate}${date} ${hours}${dividerTime}${minutes}${dividerTime}${seconds}`
  }
  return newDateTime
}

/**
 * @desc 转换省市区数据格式
 * 将标准的省市区格式：{"110000":"北京市","120000":"天津市","130000":"河北省"……}，转换为 element-ui select 组件支持的数组形式：[{'110000':'北京市'},{'120000':'天津市'}，{'130000':'河北省'}……]
 */
function ObjectToArray(object) {
  return new Promise((resolve) => {
    let arr = []
    for (let key in object) {
      arr.push({
        label: object[key],
        value: key,
      })
    }
    resolve(arr)
  })
}
/**
 * @desc 延迟执行，这个方式可以减少嵌套和代码量
 * @param timer 延迟时长（毫秒单位）
 */
function Wait(timer = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, timer)
  })
}

/**
 * @desc 对象序列化反序列化法
 */
function ObjectDeepClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * @desc 两个时间差额
 */
function DiffTimestamp(timeBegin, timeEnd) {
  let beginTime = new Date(timeBegin).getTime()
  let endTime = new Date(timeEnd).getTime()

  let diff = endTime - beginTime
  if (diff >= 0) {
    // 返回相差秒数
    return diff / 1000
  }

  return false
}

/**
 * @desc 删除左右两端的空格
 * @param str 要处理的字符串
 * @param type 删除类型：默认全部、lr：左右、l：左边、r：右边
 */
function Trim(str, type = '') {
  let strTrim = ''
  switch (type) {
    case 'lr':
      strTrim = str.replace(/(^\s*)|(\s*$)/g, '')
      break

    case 'l':
      strTrim = str.replace(/(^\s*)/g, '')
      break

    case 'r':
      strTrim = str.replace(/(\s*$)/g, '')
      break

    default:
      strTrim = str.replace(/\s+/g, '')
  }

  return strTrim
}

/**
 * @desc 根据rank类型完成快速排序
 * @param arr 待排序数组
 * @param type1 进行排序的数据
 * @param type2 进行排序的类型
 */
function QicukSort(arr, type1, type2) {
  if (arr.length <= 1) {
    return arr
  }
  let pivotIndex = Math.floor(arr.length / 2)
  let pivotElement = arr.splice(pivotIndex, 1)[0]
  let pivot = pivotElement.rank[type1][type2].rank
  let left = []
  let right = []
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].rank[type1][type2].rank < pivot) {
      left.push(arr[i])
    } else {
      right.push(arr[i])
    }
  }
  return QicukSort(left, type1, type2).concat(
    [pivotElement],
    QicukSort(right, type1, type2)
  )
}

/**
 * @desc 设置微信分享信息
 * @param wx 微信sdk对象
 * @param data 请求到的配置信息
 * @param url 当前页面路径
 * @param imgUrl 分享配图
 */
function SetWechatShare(wx, data, url, imgUrl) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.config.appId, // 必填，公众号的唯一标识
    timestamp: data.config.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
    signature: data.config.signature, // 必填，签名
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
  })
  wx.ready(function () {
    wx.updateAppMessageShareData({
      title: data.info.title, // 分享标题
      desc: data.info.desc, // 分享描述
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        // 设置成功
        // alert('updateAppMessageShareData success')
      },
    })
    wx.updateTimelineShareData({
      title: data.info.title, // 分享标题
      link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        // 设置成功
        // alert('updateTimelineShareData success')
      },
    })
  })
}

// 公共方法，首字母大写
export {
  FormatDateTime,
  ObjectToArray,
  Wait,
  ObjectDeepClone,
  DiffTimestamp,
  Trim,
  QicukSort,
  SetWechatShare,
}
